import React from 'react';
import './addressTable.css';
import PropTypes from 'prop-types';

const KeyValueTable = ({ title, data = [], onChange }) => {
  const handleChange = (index, value) => {
    const newData = [...data];
    newData[index].value = value;
    onChange(newData);
  };

  return (
    <div style={{ marginBottom: '30px' }}>
      <h5 style={{ fontWeight: 'bold' }}>{title}</h5>

      <table className="address-table">
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td className="kv-label">{item.label}</td>
              <td className="kv-value">
                <input
                  type="text"
                  className="form-control"
                  value={item.value || ''}
                  onChange={e => handleChange(index, e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

KeyValueTable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  onChange: PropTypes.func
};
export default KeyValueTable;

